import { createFileRoute, Link } from "@tanstack/react-router";
import { loadTalkList } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/talks/")({
  loader: () => loadTalkList(),
  head: () => ({
    meta: seo({
      title: "Talks",
      description: "Watch talks and webinars from the C1 team on identity security and access governance.",
      url: "/talks",
    }),
    links: seoLinks({ url: "/talks" }),
  }),
  component: TalksIndex,
});

function TalksIndex() {
  const talks = Route.useLoaderData();
  return (
    <div className="mx-auto max-w-screen-xl px-4 py-16 md:px-8">
      <h1 className="mb-2 font-display text-4xl font-bold text-charcoal">Talks</h1>
      <p className="mb-12 font-body text-lg text-gray-60">Talks and webinars on identity security and access governance.</p>
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {talks.map((t) => (
          <Link key={t.slug} to="/talks/$slug" params={{ slug: t.slug }} className="group overflow-hidden rounded-lg border border-[#DCDADA] transition-shadow hover:shadow-card">
            {t.featured_image && (
              <div className="aspect-video overflow-hidden bg-gray-6">
                <img src={t.featured_image} alt={t.title} className="h-full w-full object-cover" loading="lazy" />
              </div>
            )}
            <div className="p-5">
              <div className="mb-2 text-xs text-gray-60">
                <time>{new Date(t.date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</time>
                {t.speaker && <> &middot; {t.speaker}</>}
              </div>
              <h2 className="font-body text-lg font-bold text-charcoal group-hover:text-teal-dark">{t.title}</h2>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
